import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import Select from 'react-select'
// import {
//   ContainerDivs,
//   Link,
//   LinkIcon
// } from '../../components'

import Styles from './SelectDropdownPlan.css'

// EXAMPLE USE IN FossilFuelBondsIn401ks
// <SelectDropdownPlan
//   plans={config.plansBondsSource}
//   value={this.state.planSelected}
//   onChange={this.onPlanSelect}
// />

@CSSModules(Styles, {allowMultiple:true})
export default class SelectDropdownPlan extends Component {
  static propTypes = {
    plans: PropTypes.object,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props)
    // if provided a specific list of plans.
    // else use all plans.
    const plans = this.props.plans || config.plansSource
    // default value, otherwise use value provided.
    const defaultValue = {
      name: 'Select an employer',
      label: 'Select  an employer'
    }
    const value = this.props.value || defaultValue
    this.state = {
      defaultValue,
      value,
      planSelectOptions: Object.keys(plans).map((key, i) => {
        return {
          name: key,
          label: config.plansSource[key].short_name
        }
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({value: nextProps.value || this.state.defaultValue})
    }
  }

  render() {
    return (
      <Select
        name='plan-select'
        value={this.state.value}
        options={this.state.planSelectOptions}
        onChange={this.props.onChange}
      />
    )
  }
}

